import { render } from "./TradeHeader.vue?vue&type=template&id=3b43832e&ts=true"
import script from "./TradeHeader.vue?vue&type=script&lang=ts"
export * from "./TradeHeader.vue?vue&type=script&lang=ts"

import "./TradeHeader.vue?vue&type=style&index=0&id=3b43832e&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__